import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted } from 'vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import type { RouteRecordName } from 'vue-router'

import type { LinkElement } from './index'


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'SidebarMenuElement',
  props: {
    condensed: { type: Boolean },
    href: {},
    to: {},
    icon: {},
    label: {},
    counter: {},
    children: {},
    drop: { type: Boolean },
    disabled: { type: Boolean },
    initialState: { type: Boolean },
    isDropped: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();


const props = __props
const opened = ref(false)

const currentPath = window.location.pathname

const route = useRoute()
const router = useRouter()

const elementState = computed(() => ({
  'is-condensed': props.condensed,
  'is-opened': opened.value,
}))

watch(
  () => props.condensed,
  (val, old) => {
    if (val !== old) {
      if (val) {
        opened.value = !val
      } else {
        opened.value = checkNestedActive(router?.currentRoute.value) || props.isDropped
      }
    }
  }
)

onBeforeRouteUpdate((to) => {
  opened.value = !props.condensed && checkNestedActive(to) || !props.condensed && props.isDropped
})

onMounted(() => {
  opened.value =
    !props.condensed && checkNestedActive(router?.currentRoute.value) || !props.condensed && props.isDropped
})

function checkNestedActive({
  name: currentName,
}: RouteRecordName | null | undefined): boolean {
  if (props.children && props.children.length) {
    return !!(
      currentName &&
      props.children.some(
        ({
          to: { name = '' } = {
            name: '',
            params: {},
          },
        }) => name === currentName
      )
    )
  }
  return false
}

function outside() {
  if (props.condensed) {
    close()
  }
}

function open(): void {
  if (opened.value === true) {
    return
  }
  opened.value = true
}

function close(): void {
  if (opened.value === false) {
    return
  }
  opened.value = false
}

function toggle(event: Event, second: string): void {
  if (!props.condensed && props.children && props.children.length) {
    // event.preventDefault()
    // event.stopImmediatePropagation?.()
    // event.stopPropagation()
  }
  if (opened.value) {
    close()
  } else {
    open()
  }
}

const __returned__ = { props, opened, currentPath, route, router, elementState, checkNestedActive, outside, open, close, toggle, computed, ref, watch, onMounted, get onBeforeRouteUpdate() { return onBeforeRouteUpdate }, get useRoute() { return useRoute }, get useRouter() { return useRouter } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})